import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'longmoon-illuminating-co',
  templateUrl: './illuminating-co.component.html',
  styleUrls: ['./illuminating-co.component.scss']
})
export class IlluminatingCoComponent implements OnInit {
  pageTitle: string;
  mockIlluminatingCoWeb = '../../../assets/img/illuminating-company/mock-illuminating-co-web.png';
  mockIlluminatingCoWebLogin = '../../../assets/img/illuminating-company/mock-illuminating-co-web-login.png';
  mockIlluminatingCoWebNav = '../../../assets/img/illuminating-company/mock-illuminating-co-web-nav.png';
  mockIlluminatingCoPhone = '../../../assets/img/illuminating-company/mock-illuminating-co-phone.png';
  mockIlluminatingCoPhoneMenu = '../../../assets/img/illuminating-company/mock-illuminating-co-phone-menu.png';

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.pageTitle = this.route.snapshot.data.pageTitle;
  }
}
